'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00249 from "./presto.-Register-Page-View$$anon$9.js";
import * as $j_presto$002etypes$0024$002dCompact$002dGroup$0024 from "./presto.types$-Compact-Group$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$8() {
  this.bvU = null;
  this.bvM = null;
  this.bvN = false;
  this.bvV = null;
  this.bvW = false;
  this.bvZ = null;
  this.bvS = null;
  this.bvT = false;
  this.bvO = null;
  this.bvP = false;
  this.bvQ = null;
  this.bvR = false;
  this.bvX = false;
  this.bvY = false;
  this.bvU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bvZ = "CompactGroup";
}
export { $c_Lpresto_RegisterPageView$$anon$8 as $c_Lpresto_RegisterPageView$$anon$8 };
$p = $c_Lpresto_RegisterPageView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$8;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$8() {
}
export { $h_Lpresto_RegisterPageView$$anon$8 as $h_Lpresto_RegisterPageView$$anon$8 };
$h_Lpresto_RegisterPageView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bvU;
});
$p.M = (function() {
  if ((!this.bvN)) {
    this.bvM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bvN = true;
  }
  return this.bvM;
});
$p.O = (function() {
  if ((!this.bvW)) {
    this.bvV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bvW = true;
  }
  return this.bvV;
});
$p.D = (function() {
  return this.bvZ;
});
$p.t = (function() {
  if ((!this.bvT)) {
    this.bvS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bvT = true;
  }
  return this.bvS;
});
$p.N = (function() {
  if ((!this.bvP)) {
    this.bvO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kF())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bvP = true;
  }
  return this.bvO;
});
$p.Q = (function() {
  if ((!this.bvR)) {
    this.bvQ = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00249.$c_Lpresto_RegisterPageView$$anon$9();
    this.bvR = true;
  }
  return this.bvQ;
});
$p.v = (function() {
  if ((!this.bvY)) {
    this.bvX = false;
    this.bvY = true;
  }
  return this.bvX;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee72) => ((p) => \u03b4scrutinee72.adF(p)))($j_presto$002etypes$0024$002dCompact$002dGroup$0024.$m_Lpresto_types$CompactGroup$())));
});
var $d_Lpresto_RegisterPageView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$8, "presto.RegisterPageView$$anon$8", ({
  Qf: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$8 as $d_Lpresto_RegisterPageView$$anon$8 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$8.js.map
